import { NotificationListPage } from "@/pages/notification-list";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

export const Route = createFileRoute("/_auth_requeired/notifications/")({
  component: () => {
    return <NotificationListPage />;
  },
  validateSearch: z.object({
    page: z.number().min(1).default(1),
    perPage: z.number().min(1).default(50),
  }),
});
